import { useMutation } from 'react-query'
import { deleteAPI } from 'framework/api/http'

interface DeleteEmailRecipientInterface {
  id?: string
}

export const useDeleteEmailRecipient = () => {
  const mutate = useMutation(({ id }: DeleteEmailRecipientInterface) => {
    return deleteAPI(`/NotificationRecipient/Delete/${id}`)
  })

  return mutate
}

export default useDeleteEmailRecipient
